module.exports = __webpack_public_path__ + "static/media/nav-icon-readiness-zone-inactive.24ef2395.svg";